import React from "react";
import { Box, Grid2, Tooltip } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import LockIcon from "@mui/icons-material/Lock";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  FOLLOW_UP_COPY,
  FOLLOW_UP_COPY_PRACTITIONER,
  FOLLOW_UP_BUTTON_TEXT,
  CONSULTATION_GATE_MESSAGE,
  AGREEMENT_GATE_MESSAGE,
  TELEHEALTH_CONSENT_GATE_MESSAGE,
} from "../AppointmentDetailsModal.constants";
import {
  StyledFollowUpBox,
  StyledFollowUpText,
  StyledFollowUpButton,
} from "../AppointmentDetailsModal.styles";

const AppointmentDetailsModalFollowUpSection = ({
  appointment,
  onBookFollowUp,
  onClose,
  isFreeConsultation,
  isPractitioner = false,
  consultationCompleted = true,
  agreementSigned = true,
  telehealthConsentSigned = true,
}) => {
  const copy = isPractitioner ? FOLLOW_UP_COPY_PRACTITIONER : FOLLOW_UP_COPY;

  // Gate 1: Consultation must be completed first
  if (!consultationCompleted) {
    return (
      <Grid2 item size={{ xs: 12 }}>
        <StyledFollowUpBox sx={{ opacity: 0.7 }}>
          <StyledFollowUpText variant="body2">
            {CONSULTATION_GATE_MESSAGE}
          </StyledFollowUpText>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Tooltip title={CONSULTATION_GATE_MESSAGE} arrow>
              <span>
                <StyledFollowUpButton
                  text={FOLLOW_UP_BUTTON_TEXT}
                  startIcon={<LockIcon />}
                  disabled
                />
              </span>
            </Tooltip>
          </Box>
        </StyledFollowUpBox>
      </Grid2>
    );
  }

  // Gate 2: Participation Agreement must be signed
  if (!agreementSigned) {
    return (
      <Grid2 item size={{ xs: 12 }}>
        <StyledFollowUpBox sx={{ opacity: 0.7 }}>
          <StyledFollowUpText variant="body2">
            {AGREEMENT_GATE_MESSAGE}
          </StyledFollowUpText>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Tooltip title={AGREEMENT_GATE_MESSAGE} arrow>
              <span>
                <StyledFollowUpButton
                  text={FOLLOW_UP_BUTTON_TEXT}
                  startIcon={<DescriptionIcon />}
                  disabled
                />
              </span>
            </Tooltip>
          </Box>
        </StyledFollowUpBox>
      </Grid2>
    );
  }

  // Gate 3: Telehealth Informed Consent must be signed
  if (!telehealthConsentSigned) {
    return (
      <Grid2 item size={{ xs: 12 }}>
        <StyledFollowUpBox sx={{ opacity: 0.7 }}>
          <StyledFollowUpText variant="body2">
            {TELEHEALTH_CONSENT_GATE_MESSAGE}
          </StyledFollowUpText>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Tooltip title={TELEHEALTH_CONSENT_GATE_MESSAGE} arrow>
              <span>
                <StyledFollowUpButton
                  text={FOLLOW_UP_BUTTON_TEXT}
                  startIcon={<DescriptionIcon />}
                  disabled
                />
              </span>
            </Tooltip>
          </Box>
        </StyledFollowUpBox>
      </Grid2>
    );
  }

  return (
    <Grid2 item size={{ xs: 12 }}>
      <StyledFollowUpBox>
        <StyledFollowUpText variant="body2">
          {isFreeConsultation ? copy.freeConsultation : copy.default}
        </StyledFollowUpText>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <StyledFollowUpButton
            text={FOLLOW_UP_BUTTON_TEXT}
            startIcon={<EventIcon />}
            onClick={() => {
              onBookFollowUp(appointment);
              onClose();
            }}
          />
        </Box>
      </StyledFollowUpBox>
    </Grid2>
  );
};

export default AppointmentDetailsModalFollowUpSection;
